<!--
Description
Add an bootstrap icon inside a button wich can be clicked

Usage
 <Icon icon="pencil" title="aanpassen" v-on:clicked="editUser(user)" success></Icon>

 @prop  String  icon        the name of the bootstrap icon https://icons.getbootstrap.com/
 @prop  String  title       the tooltip text
 @prop  Boolean danger, info, success, ...       color of the button, ommit when you just want the icon

 @event  clicked     when clicked the click will be emitted to clicked, nothing more

 TODOs
 - add color to the damn svg

-->

<template>
<div class="icon">
 <button :class="{ 'btn-danger': danger, 'btn-info': info, 'btn-success': success }"  class="btn m-1" @click="clicked"> 
     <img  :src='"../assets/icons/" + this.icon + ".svg"' alt :title="title"/>
 </button>

</div>
</template>

<script>
export default {
  name: "Icon",
  data() {
    return {
    };
  },
  props: {
    title: String,
    icon: String,
    danger: Boolean,
    info: Boolean,
    success: Boolean,
  },
  methods: {
      clicked(){
          this.$emit('clicked')
      }
  }
};
</script>


<style scoped>
.icon {
    display: inline;
}
</style>